export default __webpack_public_path__ + "static/media/overviewicon.ffbd5515.svg";